import { ProductTemplate } from 'components/common/types/DirectSalesProductTemplate.types';

export const DEFAULT_PRODUCT_TEMPLATE: ProductTemplate = {
  status: '',
  rules: [],
  productTemplate: {
    id: '',
    name: '',
  },
  folder: '',
  dealLineId: '',
};
